/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DashboardSpiderUseCase
 */
export interface DashboardSpiderUseCase {
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderUseCase
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof DashboardSpiderUseCase
   */
  useCase: string;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderUseCase
   */
  performanceValue: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderUseCase
   */
  robustnessValue: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderUseCase
   */
  explainabilityValue: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderUseCase
   */
  fairnessValue: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderUseCase
   */
  totalValue: number;
}

/**
 * Check if a given object implements the DashboardSpiderUseCase interface.
 */
export function instanceOfDashboardSpiderUseCase(value: object): value is DashboardSpiderUseCase {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('performanceValue' in value) || value['performanceValue'] === undefined) return false;
  if (!('robustnessValue' in value) || value['robustnessValue'] === undefined) return false;
  if (!('explainabilityValue' in value) || value['explainabilityValue'] === undefined) return false;
  if (!('fairnessValue' in value) || value['fairnessValue'] === undefined) return false;
  if (!('totalValue' in value) || value['totalValue'] === undefined) return false;
  return true;
}

export function DashboardSpiderUseCaseFromJSON(json: any): DashboardSpiderUseCase {
  return DashboardSpiderUseCaseFromJSONTyped(json, false);
}

export function DashboardSpiderUseCaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardSpiderUseCase {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    useCase: json['use_case'],
    performanceValue: json['performance_value'],
    robustnessValue: json['robustness_value'],
    explainabilityValue: json['explainability_value'],
    fairnessValue: json['fairness_value'],
    totalValue: json['total_value'],
  };
}

export function DashboardSpiderUseCaseToJSON(value?: DashboardSpiderUseCase | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    use_case: value['useCase'],
    performance_value: value['performanceValue'],
    robustness_value: value['robustnessValue'],
    explainability_value: value['explainabilityValue'],
    fairness_value: value['fairnessValue'],
    total_value: value['totalValue'],
  };
}
